module.exports = __webpack_public_path__ + "img/expostyle_0007_orange_pantone166c.138b73c8.jpg";